/**
 * EventsDetailPanel — Shows the status events table for a selected stage.
 */
import Box from '@cloudscape-design/components/box';
import Badge from '@cloudscape-design/components/badge';
import Header from '@cloudscape-design/components/header';
import Table from '@cloudscape-design/components/table';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { StatusEvent } from 'src/store/slices/payment/paymentState';
import { formatTimestamp } from 'src/utils/formatters';

interface EventsDetailPanelProps {
  stageName: string;
  events: StatusEvent[];
}

const badgeColor = (state: string) => {
  if (state === 'SUCCESS') return 'green' as const;
  if (state === 'FAILED') return 'red' as const;
  return 'blue' as const;
};

export const EventsDetailPanel = ({ stageName, events }: EventsDetailPanelProps) => (
  <SpaceBetween size="s">
    <Header variant="h3">{stageName.replace(/_/g, ' ')} — Events</Header>
    <Table
      variant="embedded"
      sortingDisabled
      columnDefinitions={[
        {
          id: 'time',
          header: 'Time',
          cell: (item: StatusEvent) => formatTimestamp(item.timestamp),
        },
        {
          id: 'state',
          header: 'State',
          cell: (item: StatusEvent) => (
            <Badge color={badgeColor(item.state)}>{item.state}</Badge>
          ),
        },
        {
          id: 'status',
          header: 'Status',
          cell: (item: StatusEvent) => item.status || '-',
        },
      ]}
      items={events}
      empty={<Box textAlign="center" color="text-body-secondary">No events</Box>}
    />
  </SpaceBetween>
);
